import { Component } from '@angular/core';

@Component({
  selector: 'app-temp-reload',
  standalone: false,
  templateUrl: './temp-reload.component.html' 
})
export class TempReloadComponent {

}
